import { Button } from '@peacecover/component';
import type { DefaultTFuncReturn } from 'i18next';

interface PopUpBasicProps {
  type: 'large' | 'short';
  title?: string | DefaultTFuncReturn;
  description: string | React.ReactNode | DefaultTFuncReturn;
  primaryButtonText?: string | DefaultTFuncReturn;
  secondaryButtonText?: string | DefaultTFuncReturn;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  content?: React.ReactNode;
  className?: string;
}

const PopUpBasic = ({
  type,
  title,
  description,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  content,
  className = ''
}: PopUpBasicProps) => {
  const baseClasses = 'bg-background-elevated rounded-[24px] px-[14px] pt-[32px] pb-[16px] mb-[10px]';

  if (type === 'large') {
    return (
      <div className={`flex flex-col gap-[40px] ${baseClasses} ${className}`}>
        <div className="flex flex-col gap-[8px] leading-none items-center">
          <p className="leading-tight text-text-main-lv1 font-bold text-[17px] whitespace-pre-line text-center">
            {title}
          </p>
          <p className="text-text-main-lv4 text-[15px] leading-[18px] whitespace-pre-line text-center">
            {description}
          </p>
        </div>
        <div className="flex flex-col gap-[8px] leading-none">
          {primaryButtonText && (
            <Button
              btnColor="primary"
              size="large"
              onClick={onPrimaryButtonClick}
              className="text-[17px] font-semibold"
            >
              {primaryButtonText}
            </Button>
          )}
          {secondaryButtonText && (
            <Button
              btnColor="secondary"
              size="large"
              onClick={onSecondaryButtonClick}
              className="text-[17px] font-semibold"
            >
              {secondaryButtonText}
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex flex-col ${content ? 'gap-[24px]' : 'gap-[36px]'} ${baseClasses} ${className}`}
    >
      <div className="flex flex-col gap-[8px] leading-none items-center">
        <p className="leading-[20px] text-text-main-lv1 font-bold text-[17px] text-center whitespace-pre-line">
          {title}
        </p>
        <p className="text-text-main-lv4 text-[15px] leading-[18px] whitespace-pre-line text-center">
          {description}
        </p>
      </div>
      {content}
      <div className="flex gap-[7px] leading-none">
        <Button
          btnColor="secondary"
          size="large"
          onClick={onPrimaryButtonClick}
          className="text-[17px] font-semibold w-full"
        >
          {primaryButtonText}
        </Button>
        <Button
          btnColor="primary"
          size="large"
          onClick={onSecondaryButtonClick}
          className="text-[17px] font-semibold w-full"
        >
          {secondaryButtonText}
        </Button>
      </div>
    </div>
  );
};

export default PopUpBasic;
